const styleDetails = {
	paddingLeft: "7%",
	margin: "10px",
	fontSize: "1.3rem",
}; // style for detail penals of table

const optionsTable = (data) => {
	return {
		actionsColumnIndex: -1,
		sorting: true,
		pageSize: 15,
		pageSizeOptions: [15, 30, 45, { value: data?.length !== 0 ? data?.length : '0', label: "All" }],
		emptyRowsWhenPaging: false,
		searchable: true,
	};
}; // options for table

export {styleDetails, optionsTable};